/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storyDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	imageId: z.string().nullable(),
	image: z.object({
		id: z.string(),
		name: z.string(),
		fileName: z.string(),
		category: z.union([z.literal('image'), z.literal('file')]),
		mimeType: z.string().nullable(),
		size: z.number(),
		humanReadableSize: z.string(),
		url: z.string(),
		collectionName: z.union([
			z.literal('ad-asset'),
			z.literal('baked-story'),
			z.literal('baked-feed'),
			z.literal('story'),
			z.literal('feed'),
			z.literal('landing-page'),
			z.literal('logo'),
			z.literal('generated'),
			z.literal('uploaded'),
			z.literal('imported'),
			z.literal('candidate-files'),
			z.literal('custom-font'),
			z.literal('design'),
			z.literal('whatsapp-profile'),
		]),
		width: z.number(),
		height: z.number(),
		isPlaceholder: z.boolean(),
		isGenerating: z.boolean(),
		createdAt: z.iso.datetime(),
		isGenerated: z.boolean().default(false),
		startedGenerationAt: z.iso.datetime().nullable(),
		finishedGenerationAt: z.iso.datetime().nullable(),
		meta: z.record(z.string(), z.unknown()).nullable(),
	}).nullable(),
	imagesHistory: z.array(
		z.object({
			historyUpdatedAt: z.iso.datetime(),
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable(),
			size: z.number(),
			humanReadableSize: z.string(),
			url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().default(false),
			startedGenerationAt: z.iso.datetime().nullable(),
			finishedGenerationAt: z.iso.datetime().nullable(),
			meta: z.record(z.string(), z.unknown()).nullable(),
		}),
	),
	campaignId: z.string(),
	title: z.string(),
	subtitle: z.string(),
	button: z.string(),
	location: z.string(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type StoryDataSchema = z.infer<typeof storyDataSchema>
